import type { Field } from '@lighthouse/core'

export const defaultFormat = 'yyyy-MM-dd HH:mm'

export const emptyBoolField: Field = {
    type: 'checkbox',
    dsId: '',
    id: '',
    name: '',
    innerType: 'BOOL',
    checkbox: {}
}

export const emptyNumberField: Field = {
    type: 'number',
    dsId: '',
    id: '',
    name: '',
    innerType: 'NUMBER',
    number: {}
}

export const emptyTextField: Field = {
    type: 'text',
    dsId: '',
    id: '',
    name: '',
    innerType: 'TEXT'
}
